import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { PaymentDetailsResponseDto } from './dto/payment-details-response-dto';
import { PaymentEnabledDto, PaymentEnabledResponseDto } from './dto/payment-enabled-dto';
import { PaymentIntentDto } from './dto/payment-intent-dto';
import { PaymentIntentResponseDto } from './dto/payment-intent-response-dto';
import { NewSessionWire } from './models/tuna.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentApiService {
  constructor(private http: HttpClient) {}

  intent(
    paymentIntentDto: PaymentIntentDto
  ): Observable<PaymentIntentResponseDto> {
    return this.http.post<PaymentIntentResponseDto>(
      `payments/intent`,
      paymentIntentDto
    );
  }

  details(uuid: string): Observable<PaymentDetailsResponseDto> {
    return this.http.get<PaymentDetailsResponseDto>(`payments/${uuid}`);
  }

  enabled(idi: number): Observable<PaymentEnabledDto[]> {
    return this.http.get<PaymentEnabledResponseDto>(`payments/${idi}/enabled`).pipe(map((res: PaymentEnabledResponseDto) => {
      return res.data as PaymentEnabledDto[];
    }));
  }

  createTunaSession(customerId: string, customerEmail: string, idi?: number): Observable<NewSessionWire> {
    // idi lets the backend find the marketplace token the payments API requires on new-session.
    const body = { id: customerId, email: customerEmail, idi };
    return this.http.post<NewSessionWire>(`payments/tuna/new-session`, body);
  }

  cancel(uuid: string): Observable<PaymentDetailsResponseDto> {
    return this.http.post<PaymentDetailsResponseDto>(`payments/${uuid}/cancel`, {});
  }
}
